export { ErrorPage } from './ErrorPage';
export type { ErrorPageProps } from './ErrorPage';
